import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicPerformanceMetrics = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Performance Metrics: Execution Time Calculation, MIPS, MFLOPS"
      videos={[
        "https://www.youtube.com/embed/uHqbE3JiDPY",
        "https://www.youtube.com/embed/3ox4E1b1_NQ",
        "https://www.youtube.com/embed/3ox4E1b1_NQ"
      ]}
      takeaways={[
        { text: "Only numerical questions from this topic." },
        { text: "Remember all the formulas as questions can be twisted in many ways." },
        { text: "Be clear about what every term in the formula means." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicPerformanceMetrics;
